// extracted by mini-css-extract-plugin
module.exports = {"container":"Bills_container_113lH","noAccess":"Bills_noAccess_13pam","infoTable__col":"Bills_infoTable__col_2uVPn","infoTable__col_large":"Bills_infoTable__col_large_2Z5zg"};